// extracted by mini-css-extract-plugin
export var blue = "_k-f";
export var brand = "_k-b";
export var darkGrey = "_k-e";
export var disabled = "_k-4";
export var disabledSubtle = "_k-5";
export var error = "_k-6";
export var green = "_k-g";
export var grey = "_k-d";
export var icon = "_k-0";
export var inherit = "_k-a";
export var lightGrey = "_k-c";
export var orange = "_k-i";
export var pink = "_k-k";
export var primary = "_k-1";
export var purple = "_k-l";
export var red = "_k-j";
export var secondary = "_k-2";
export var success = "_k-9";
export var tertiary = "_k-3";
export var warning = "_k-7";
export var warningSecondary = "_k-8";
export var white = "_k-m";
export var yellow = "_k-h";